import { baseApi } from "api/BaseApi";

import { PclCounts, PublicPclProduct } from "./product.types";

export const publicProductApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAllPclProducts: build.query<PublicPclProduct[], void>({
      query: () => ({
        url: "project/product/pcl_products_all/",
      }),
    }),

    loadProductPclCounts: build.query<PclCounts, void>({
      query: () => "/project/product/get_pcl_counts/",
      transformResponse: (response: Omit<PclCounts, "total">) => {
        if (!response)
          return {
            certified: 0,
            in_evaluation: 0,
            archived: 0,
            total: 0,
          };

        const total =
          response.certified + response.in_evaluation + response.archived;
        return { ...response, total };
      },
    }),
  }),

  overrideExisting: false,
});

export const { useGetAllPclProductsQuery, useLoadProductPclCountsQuery } =
  publicProductApi;
